module.exports = __webpack_public_path__ + "img/content1.ef11984c.png";